import {ErrorDisplayProps, withErrorSubscribe} from './withErrorSubscribe'
import {ErrorMessageProps, withErrorMessage} from './withErrorMessage'
import React from 'react'
import {HintProps, withHint} from './withHintButton'

export type ErrorHandlingFormProps =
    ErrorDisplayProps &
    HintProps &
    ErrorMessageProps


export const createErrorHandlingForm = <OriginalProps extends {}>(
    WrappedComponent: React.ComponentType<OriginalProps & ErrorHandlingFormProps>,
) =>
    withErrorSubscribe(
        withErrorMessage(
            withHint(WrappedComponent)))
